<!-- //
echarts-bar
@auth xuyd
@date 2024-05-01
//-->
<template>
  <div class="widget-view" ref="ref_widgetEchartsBar" :style="{
      width: this.$util.num2px(viewProps.width),
      height: this.$util.num2px(viewProps.height)
  }">
  </div>
</template>

<script>
import ApiDesignApi from "@/api/datasvc/apiDesign.api";

export default {
  name: 'WidgetEchartsBarView',
  components: {},
  data() {
    return {
      myChart: null,
    }
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    viewProps() {
      return this.widgetProps.viewProps;
    },
    datasourceProps() {
      return this.widgetProps.datasourceProps;
    }
  },
  watch: {
    'widgetProps.datasourceProps': {
      handler: function (val) {
        // console.log("========watch widgetProps.datasourceProps========>", JSON.stringify(val));
        this.handleFetchData().then((data) => {this.handleFillData(data)});
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.init();
    this.handleFetchData().then((data) => {this.handleFillData(data)});
  },
  methods: {
    // 父组件resize触发子组件
    handleResize() {
      this.myChart.resize();
    },
    init() {
      let $el = this.$refs.ref_widgetEchartsBar;
      this.myChart = this.$echarts.init($el);
      window.addEventListener('resize', this.handleResize);
      this.myChart.clear();
      // console.log('---init--->', JSON.stringify(this.widgetProps.viewProps.chartOption));
      this.myChart.setOption(this.widgetProps.viewProps.chartOption);
    },

    /**
     * 获取数据
     */
    handleFetchData() {
      return new Promise((resolve, reject) => {
        if (this.datasourceProps.datasourceType === 'STATIC') {
          let respData = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType].data;
          resolve(respData);
        } else if (this.datasourceProps.datasourceType === 'API') {
          let dataConfig = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType];
          if (dataConfig && dataConfig.datasource) {
            let reqParams = (typeof dataConfig.reqParams === 'string') ? JSON.parse(dataConfig.reqParams) : dataConfig.reqParams;
            ApiDesignApi.runApi(dataConfig.datasource, reqParams).then(resp => {
              console.log(`======${this.$route.name} respData====>`, resp);
              resolve(resp.data);
            });
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },

    /**
     * 填充数据  映射[{xAxis: 'data', series:'value'}]
     * @param respData [{data: xx, value: xx}]
     */
    handleFillData(respData) {
      let dataList = (typeof respData === 'string') ? JSON.parse(respData) : respData;
      let xAxisMapping = this.datasourceProps.dataMapping.find(item => item.prop === 'xAxis');
      let seriesMapping = this.datasourceProps.dataMapping.find(item => item.prop === 'series');
      let nameList = dataList.map(item => {
        return item[xAxisMapping.field];
      });

      let valueList = dataList.map(item => {
        return item[seriesMapping.field];
      });

      this.widgetProps.viewProps.chartOption.xAxis[0].data = nameList;
      this.widgetProps.viewProps.chartOption.series[0].data = valueList;

      // console.log("========handleFillData========>", this.widgetProps.viewProps.chartOption);
      this.myChart?.clear();
      this.myChart?.setOption(this.widgetProps.viewProps.chartOption);
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}

</script>
<style lang="less" scoped>
.widget-view {
  width: 100%;
  height: 100%;
}
</style>
